export default {
  get({ values }) {
    return [200, 'test Message']
  },
  async post({ data }) {
    await new Promise((resolve) => setTimeout(resolve, 1000))
    return { status: 201, data: { accessToken: 'testtoken', refreshToken: 'refreshtoken' } }
  },
}
